
import Vue from 'vue'

const locales = {keys(){return []}}
global['____GE7F341C____'] = true;
delete global['____GE7F341C____'];
global.__uniConfig = {"globalStyle":{"navigationBarTextStyle":"black","navigationBarTitleText":"Happy交易所","navigationBarBackgroundColor":"#007AFF","backgroundColor":"#FFFFFF","titleNView":false},"easycom":{"autoscan":true,"custom":{"^van-(.*)":"@/wxcomponents/vant/$1/index.vue","v-button":"@/layout/vButton.vue","v-input":"@/layout/vInput.vue","v-header":"@/layout/vHeader.vue","v-code":"@/layout/vCode.vue","v-country":"@/layout/vCountry.vue","v-link":"@/layout/vLink.vue","v-notice-bar":"@/layout/vNoticeBar.vue","v-lang":"@/layout/vLang.vue","v-qr":"@/layout/vQr.vue","v-scroll":"@/layout/vScroll.vue","v-paging":"@/layout/vPaging.vue","v-curve":"@/layout/vCurve.vue","v-dropdwon":"@/layout/vDropdwon.vue","v-picker":"@/layout/vPicker.vue","v-page":"@/layout/vPage.vue","not-data":"@/layout/notData.vue","special-Banner":"@/layout/specialBanner.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"}}};
global.__uniConfig.compilerVersion = '4.36';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__GE7F341C';
global.__uniConfig.appName = 'Happy';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"./"};
global.__uniConfig.publicPath = "./";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {};
global.__uniConfig.qqMapKey = undefined;
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-startPage-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/startPage/index"+'.vue')), 'pages-startPage-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-base-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/base/index"+'.vue')), 'pages-base-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-currency-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/currency/index"+'.vue')), 'pages-currency-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-currency-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/currency/list"+'.vue')), 'pages-currency-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-exchange-exchangeHis', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/exchange/exchangeHis"+'.vue')), 'pages-exchange-exchangeHis'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-exchange-contractHis', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/exchange/contractHis"+'.vue')), 'pages-exchange-contractHis'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-exchange-his', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/exchange/his"+'.vue')), 'pages-exchange-his'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-login-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/login/index"+'.vue')), 'pages-login-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-purchase-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/purchase/index"+'.vue')), 'pages-purchase-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-purchase-bill', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/purchase/bill"+'.vue')), 'pages-purchase-bill'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-reg-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/reg/index"+'.vue')), 'pages-reg-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-reg-email', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/reg/email"+'.vue')), 'pages-reg-email'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-safe-forget-password', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/safe/forget-password"+'.vue')), 'pages-safe-forget-password'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/notice/detail"+'.vue')), 'pages-notice-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-accountSettings-accountSettings', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/accountSettings/accountSettings"+'.vue')), 'pages-accountSettings-accountSettings'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-assets-recharge', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/assets/recharge"+'.vue')), 'pages-assets-recharge'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-assets-paypal', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/assets/paypal"+'.vue')), 'pages-assets-paypal'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-assets-draw', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/assets/draw"+'.vue')), 'pages-assets-draw'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-assets-address-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/assets/address-list"+'.vue')), 'pages-assets-address-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-assets-edit-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/assets/edit-address"+'.vue')), 'pages-assets-edit-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-invite-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/invite/index"+'.vue')), 'pages-invite-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-invite-level', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/invite/level"+'.vue')), 'pages-invite-level'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-commission-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/commission/index"+'.vue')), 'pages-commission-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-commission-revoke', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/commission/revoke"+'.vue')), 'pages-commission-revoke'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-auth-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/auth/index"+'.vue')), 'pages-auth-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-auth-primary', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/auth/primary"+'.vue')), 'pages-auth-primary'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-auth-senior', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/auth/senior"+'.vue')), 'pages-auth-senior'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-safe-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/safe/index"+'.vue')), 'pages-safe-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-safe-login-password', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/safe/login-password"+'.vue')), 'pages-safe-login-password'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-safe-phone', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/safe/phone"+'.vue')), 'pages-safe-phone'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-safe-google', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/safe/google"+'.vue')), 'pages-safe-google'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-safe-transaction-password', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/safe/transaction-password"+'.vue')), 'pages-safe-transaction-password'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-safe-email', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/safe/email"+'.vue')), 'pages-safe-email'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/notice/index"+'.vue')), 'pages-notice-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-notice-msg-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/notice/msg-detail"+'.vue')), 'pages-notice-msg-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-option-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/option/index"+'.vue')), 'pages-option-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-transfer-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/transfer/index"+'.vue')), 'pages-transfer-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-transfer-bill', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/transfer/bill"+'.vue')), 'pages-transfer-bill'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-assets-bill', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/assets/bill"+'.vue')), 'pages-assets-bill'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-exchange-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/exchange/index"+'.vue')), 'pages-exchange-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-assets-account-bill', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/assets/account-bill"+'.vue')), 'pages-assets-account-bill'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-assets-currency-bill', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/assets/currency-bill"+'.vue')), 'pages-assets-currency-bill'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-help-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/help/index"+'.vue')), 'pages-help-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-help-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/help/detail"+'.vue')), 'pages-help-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-help-sort', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/help/sort"+'.vue')), 'pages-help-sort'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-list-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/list/list"+'.vue')), 'pages-list-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-option-delivery-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/option/delivery-detail"+'.vue')), 'pages-option-delivery-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-income-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/income/index"+'.vue')), 'pages-income-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-otc-send-ad', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/otc/send-ad"+'.vue')), 'pages-otc-send-ad'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-otc-order', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/otc/order"+'.vue')), 'pages-otc-order'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-otc-ad', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/otc/ad"+'.vue')), 'pages-otc-ad'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-otc-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/otc/detail"+'.vue')), 'pages-otc-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-otc-pays', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/otc/pays"+'.vue')), 'pages-otc-pays'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-otc-bind-pay', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/otc/bind-pay"+'.vue')), 'pages-otc-bind-pay'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-otc-bill', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/otc/bill"+'.vue')), 'pages-otc-bill'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-service-service', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/service/service"+'.vue')), 'pages-service-service'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-service-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/service/index"+'.vue')), 'pages-service-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-service-otc', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/service/otc"+'.vue')), 'pages-service-otc'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-upgrade-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/upgrade/index"+'.vue')), 'pages-upgrade-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('components-uni-fixed-uni-fixed-uni-fixed', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/components/uni-fixed/uni-fixed/uni-fixed"+'.vue')), 'components-uni-fixed-uni-fixed-uni-fixed'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-base-miner', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/base/miner"+'.vue')), 'pages-base-miner'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-base-destroy-coin', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/base/destroy-coin"+'.vue')), 'pages-base-destroy-coin'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-miner-miner', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/miner/miner"+'.vue')), 'pages-miner-miner'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-miner-produce', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/miner/produce"+'.vue')), 'pages-miner-produce'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-miner-power', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/miner/power"+'.vue')), 'pages-miner-power'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-miner-team', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/miner/team"+'.vue')), 'pages-miner-team'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-miner-data', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/miner/data"+'.vue')), 'pages-miner-data'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-assets-miner-bill', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("D:/Program/503h5/pages/assets/miner-bill"+'.vue')), 'pages-assets-miner-bill'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/startPage/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-startPage-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-startPage-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/startPage/index',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/base/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-base-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-base-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/base/index',
  windowTop:0
}
},
{
path: '/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
  windowTop:0
}
},
{
path: '/pages/currency/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-currency-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-currency-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/currency/index',
  windowTop:0
}
},
{
path: '/pages/currency/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-currency-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-currency-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/currency/list',
  windowTop:0
}
},
{
path: '/pages/exchange/exchangeHis',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-exchange-exchangeHis', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-exchange-exchangeHis',
  isNVue:false,maxWidth:0,
  pagePath:'pages/exchange/exchangeHis',
  windowTop:0
}
},
{
path: '/pages/exchange/contractHis',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-exchange-contractHis', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-exchange-contractHis',
  isNVue:false,maxWidth:0,
  pagePath:'pages/exchange/contractHis',
  windowTop:0
}
},
{
path: '/pages/exchange/his',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-exchange-his', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-exchange-his',
  isNVue:false,maxWidth:0,
  pagePath:'pages/exchange/his',
  windowTop:0
}
},
{
path: '/pages/login/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-login-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-login-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/login/index',
  windowTop:0
}
},
{
path: '/pages/purchase/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-purchase-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-purchase-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/purchase/index',
  windowTop:0
}
},
{
path: '/pages/purchase/bill',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-purchase-bill', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-purchase-bill',
  isNVue:false,maxWidth:0,
  pagePath:'pages/purchase/bill',
  windowTop:0
}
},
{
path: '/pages/reg/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-reg-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-reg-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/reg/index',
  windowTop:0
}
},
{
path: '/pages/reg/email',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-reg-email', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-reg-email',
  isNVue:false,maxWidth:0,
  pagePath:'pages/reg/email',
  windowTop:0
}
},
{
path: '/pages/safe/forget-password',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-safe-forget-password', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-safe-forget-password',
  isNVue:false,maxWidth:0,
  pagePath:'pages/safe/forget-password',
  windowTop:0
}
},
{
path: '/pages/notice/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-notice-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice/detail',
  windowTop:0
}
},
{
path: '/pages/accountSettings/accountSettings',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-accountSettings-accountSettings', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-accountSettings-accountSettings',
  isNVue:false,maxWidth:0,
  pagePath:'pages/accountSettings/accountSettings',
  windowTop:0
}
},
{
path: '/pages/assets/recharge',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-assets-recharge', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-assets-recharge',
  isNVue:false,maxWidth:0,
  pagePath:'pages/assets/recharge',
  windowTop:0
}
},
{
path: '/pages/assets/paypal',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-assets-paypal', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-assets-paypal',
  isNVue:false,maxWidth:0,
  pagePath:'pages/assets/paypal',
  windowTop:0
}
},
{
path: '/pages/assets/draw',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-assets-draw', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-assets-draw',
  isNVue:false,maxWidth:0,
  pagePath:'pages/assets/draw',
  windowTop:0
}
},
{
path: '/pages/assets/address-list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-assets-address-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-assets-address-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/assets/address-list',
  windowTop:0
}
},
{
path: '/pages/assets/edit-address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-assets-edit-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-assets-edit-address',
  isNVue:false,maxWidth:0,
  pagePath:'pages/assets/edit-address',
  windowTop:0
}
},
{
path: '/pages/invite/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-invite-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-invite-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/invite/index',
  windowTop:0
}
},
{
path: '/pages/invite/level',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-invite-level', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-invite-level',
  isNVue:false,maxWidth:0,
  pagePath:'pages/invite/level',
  windowTop:0
}
},
{
path: '/pages/commission/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-commission-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-commission-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/commission/index',
  windowTop:0
}
},
{
path: '/pages/commission/revoke',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-commission-revoke', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-commission-revoke',
  isNVue:false,maxWidth:0,
  pagePath:'pages/commission/revoke',
  windowTop:0
}
},
{
path: '/pages/auth/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-auth-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-auth-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/auth/index',
  windowTop:0
}
},
{
path: '/pages/auth/primary',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-auth-primary', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-auth-primary',
  isNVue:false,maxWidth:0,
  pagePath:'pages/auth/primary',
  windowTop:0
}
},
{
path: '/pages/auth/senior',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-auth-senior', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-auth-senior',
  isNVue:false,maxWidth:0,
  pagePath:'pages/auth/senior',
  windowTop:0
}
},
{
path: '/pages/safe/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-safe-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-safe-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/safe/index',
  windowTop:0
}
},
{
path: '/pages/safe/login-password',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-safe-login-password', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-safe-login-password',
  isNVue:false,maxWidth:0,
  pagePath:'pages/safe/login-password',
  windowTop:0
}
},
{
path: '/pages/safe/phone',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-safe-phone', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-safe-phone',
  isNVue:false,maxWidth:0,
  pagePath:'pages/safe/phone',
  windowTop:0
}
},
{
path: '/pages/safe/google',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-safe-google', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-safe-google',
  isNVue:false,maxWidth:0,
  pagePath:'pages/safe/google',
  windowTop:0
}
},
{
path: '/pages/safe/transaction-password',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-safe-transaction-password', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-safe-transaction-password',
  isNVue:false,maxWidth:0,
  pagePath:'pages/safe/transaction-password',
  windowTop:0
}
},
{
path: '/pages/safe/email',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-safe-email', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-safe-email',
  isNVue:false,maxWidth:0,
  pagePath:'pages/safe/email',
  windowTop:0
}
},
{
path: '/pages/notice/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-notice-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice/index',
  windowTop:0
}
},
{
path: '/pages/notice/msg-detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-notice-msg-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-notice-msg-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/notice/msg-detail',
  windowTop:0
}
},
{
path: '/pages/option/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-option-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-option-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/option/index',
  windowTop:0
}
},
{
path: '/pages/transfer/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-transfer-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-transfer-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/transfer/index',
  windowTop:0
}
},
{
path: '/pages/transfer/bill',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-transfer-bill', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-transfer-bill',
  isNVue:false,maxWidth:0,
  pagePath:'pages/transfer/bill',
  windowTop:0
}
},
{
path: '/pages/assets/bill',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-assets-bill', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-assets-bill',
  isNVue:false,maxWidth:0,
  pagePath:'pages/assets/bill',
  windowTop:0
}
},
{
path: '/pages/exchange/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-exchange-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-exchange-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/exchange/index',
  windowTop:0
}
},
{
path: '/pages/assets/account-bill',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-assets-account-bill', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-assets-account-bill',
  isNVue:false,maxWidth:0,
  pagePath:'pages/assets/account-bill',
  windowTop:0
}
},
{
path: '/pages/assets/currency-bill',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-assets-currency-bill', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-assets-currency-bill',
  isNVue:false,maxWidth:0,
  pagePath:'pages/assets/currency-bill',
  windowTop:0
}
},
{
path: '/pages/help/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-help-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-help-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/help/index',
  windowTop:0
}
},
{
path: '/pages/help/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-help-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-help-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/help/detail',
  windowTop:0
}
},
{
path: '/pages/help/sort',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-help-sort', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-help-sort',
  isNVue:false,maxWidth:0,
  pagePath:'pages/help/sort',
  windowTop:0
}
},
{
path: '/pages/list/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-list-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-list-list',
  isNVue:false,maxWidth:0,
  pagePath:'pages/list/list',
  windowTop:0
}
},
{
path: '/pages/option/delivery-detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-option-delivery-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-option-delivery-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/option/delivery-detail',
  windowTop:0
}
},
{
path: '/pages/income/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-income-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-income-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/income/index',
  windowTop:0
}
},
{
path: '/pages/otc/send-ad',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-otc-send-ad', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-otc-send-ad',
  isNVue:false,maxWidth:0,
  pagePath:'pages/otc/send-ad',
  windowTop:0
}
},
{
path: '/pages/otc/order',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-otc-order', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-otc-order',
  isNVue:false,maxWidth:0,
  pagePath:'pages/otc/order',
  windowTop:0
}
},
{
path: '/pages/otc/ad',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-otc-ad', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-otc-ad',
  isNVue:false,maxWidth:0,
  pagePath:'pages/otc/ad',
  windowTop:0
}
},
{
path: '/pages/otc/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-otc-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-otc-detail',
  isNVue:false,maxWidth:0,
  pagePath:'pages/otc/detail',
  windowTop:0
}
},
{
path: '/pages/otc/pays',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-otc-pays', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-otc-pays',
  isNVue:false,maxWidth:0,
  pagePath:'pages/otc/pays',
  windowTop:0
}
},
{
path: '/pages/otc/bind-pay',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-otc-bind-pay', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-otc-bind-pay',
  isNVue:false,maxWidth:0,
  pagePath:'pages/otc/bind-pay',
  windowTop:0
}
},
{
path: '/pages/otc/bill',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-otc-bill', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-otc-bill',
  isNVue:false,maxWidth:0,
  pagePath:'pages/otc/bill',
  windowTop:0
}
},
{
path: '/pages/service/service',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{})
      },
      [
        createElement('pages-service-service', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-service-service',
  isNVue:false,maxWidth:0,
  pagePath:'pages/service/service',
  windowTop:0
}
},
{
path: '/pages/service/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"咨询客服","navigationStyle":"default","titleNView":{}})
      },
      [
        createElement('pages-service-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-service-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/service/index',
  windowTop:44
}
},
{
path: '/pages/service/otc',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"otc","navigationStyle":"default","titleNView":{}})
      },
      [
        createElement('pages-service-otc', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-service-otc',
  isNVue:false,maxWidth:0,
  pagePath:'pages/service/otc',
  windowTop:44
}
},
{
path: '/pages/upgrade/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom"})
      },
      [
        createElement('pages-upgrade-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-upgrade-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/upgrade/index',
  windowTop:0
}
},
{
path: '/components/uni-fixed/uni-fixed/uni-fixed',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","enablePullDownRefresh":false})
      },
      [
        createElement('components-uni-fixed-uni-fixed-uni-fixed', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'components-uni-fixed-uni-fixed-uni-fixed',
  isNVue:false,maxWidth:0,
  pagePath:'components/uni-fixed/uni-fixed/uni-fixed',
  windowTop:0
}
},
{
path: '/pages/base/miner',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-base-miner', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-base-miner',
  isNVue:false,maxWidth:0,
  pagePath:'pages/base/miner',
  windowTop:0
}
},
{
path: '/pages/base/destroy-coin',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-base-destroy-coin', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-base-destroy-coin',
  isNVue:false,maxWidth:0,
  pagePath:'pages/base/destroy-coin',
  windowTop:0
}
},
{
path: '/pages/miner/miner',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-miner-miner', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-miner-miner',
  isNVue:false,maxWidth:0,
  pagePath:'pages/miner/miner',
  windowTop:0
}
},
{
path: '/pages/miner/produce',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-miner-produce', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-miner-produce',
  isNVue:false,maxWidth:0,
  pagePath:'pages/miner/produce',
  windowTop:0
}
},
{
path: '/pages/miner/power',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-miner-power', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-miner-power',
  isNVue:false,maxWidth:0,
  pagePath:'pages/miner/power',
  windowTop:0
}
},
{
path: '/pages/miner/team',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-miner-team', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-miner-team',
  isNVue:false,maxWidth:0,
  pagePath:'pages/miner/team',
  windowTop:0
}
},
{
path: '/pages/miner/data',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-miner-data', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-miner-data',
  isNVue:false,maxWidth:0,
  pagePath:'pages/miner/data',
  windowTop:0
}
},
{
path: '/pages/assets/miner-bill',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":""})
      },
      [
        createElement('pages-assets-miner-bill', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-assets-miner-bill',
  isNVue:false,maxWidth:0,
  pagePath:'pages/assets/miner-bill',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
